/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers'
import ApiToken from './ApiToken/index'
import No from './No/index'
import OAuth2 from './OAuth2/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/AddAction",
  isSubmitting
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'app',
})
let appConnectionsLengthValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'connections.length',
})
let constantData = 0
let aggregateData = fromAggregate.not(appConnectionsLengthValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 alignSelf="center"
 type={aggregateData ? "secondary" : "primary"}
 size="normal"
 onClick={onClick}
 data="app"
 disabled={appIsSubmittingData}
 text={aggregateData ? "Add new" : "Connect"}
 data="app.connections.length"
 data={0}
 aggregate="/Simple/Data/aggregate.js not"
/>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ApiToken'}>
<ApiToken
  viewPath={`${viewPath}/ApiToken`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OAuth2'}>
<OAuth2
  viewPath={`${viewPath}/OAuth2`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}